// extracted by mini-css-extract-plugin
export default {"container":"frame_container__bBF9D","app":"frame_app__gbQRb"};